module.exports = __webpack_public_path__ + "img/03.c51e761c.png";